import { Input, Tabs, TabsProps } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";

import * as styles from "./MdmCardDemoPage.module.less";
import { mdmCardDemoStore as store } from "./mdmCardDemoStore";
import { MdmCardFormDemo } from "./MdmCardFormDemo";

export const MdmCardDemoPage: React.FC = observer(() => {
  React.useEffect(() => {
    store.init();
  }, []);
  const items: TabsProps["items"] = [
    {
      key: "form",
      label: "Form",
    },
    {
      key: "data",
      label: "Data",
    },
  ];
  const { topTab } = store;
  return (
    <div className={styles.box}>
      <Tabs
        items={items}
        activeKey={store.topTab}
        onChange={(key) => store.setTopTab(key)}
      />
      <div className={styles.content}>
        {topTab === "data" && (
          <div className={styles.dataPane}>
            <Tabs
              items={store.dataItems.map(({ name }) => ({
                key: name,
                label: name,
              }))}
              activeKey={store.dataTab}
              onChange={(key) => store.setDataTab(key)}
            />
            <div className={styles.textBox}>
              <Input.TextArea
                style={{ height: "100%" }}
                value={store.curData}
                onChange={(e) => {
                  store.setCurData(e.currentTarget.value);
                }}
              />
            </div>
          </div>
        )}
        {topTab === "form" && (
          <div className={styles.formPane}>
            <MdmCardFormDemo />
          </div>
        )}
      </div>
    </div>
  );
});
